<template>
	<div id="empty-registration" :class="customClass">
		<div class="container">
			<div class="row">
				<div v-if="isFormClosed" class="col-12 title title-lg">
					Регистрация закрыта
				</div>
				<KeepAlive
					v-else
				>
					<component
						:is="currentComponent"
						:fetched-data="fetchedData"
						:block="block"
						@defineCurrentComponent="defineCurrentComponent"
					/>
				</KeepAlive>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import panel from '~/mixins/panel';
import RegistrationScenario from '~/components/panels/formulate/RegistrationScenario.vue';
import moment from '~/utils/moment';
import LandingProgramPaymentScenario from './formulate/LandingProgramPaymentScenario.vue';
import LandingProgramPaymentRedirectOkSuccessScenario from './formulate/LandingProgramPaymentRedirectOkSuccessScenario.vue';

import LoyaltyScenario from './formulate/LoyaltyScenario.vue';
import LoyaltyB2bScenario from './formulate/LoyaltyB2bScenario.vue';
import DefaultScenario from './formulate/DefaultScenario.vue';
import BookingPaymentScenario from './formulate/BookingPaymentScenario.vue';
import FamilyDayScenario from './formulate/FamilyDayScenario.vue';
import GraduationScenario from './formulate/GraduationScenario.vue';
import ProbonoScenario from './formulate/ProbonoScenario.vue';
import LeadershipDayScenario from './formulate/LeadershipDayScenario.vue';
import SKOLKOVO100Scenario from './formulate/SKOLKOVO100Scenario.vue';
import FoundationDayScenario from './formulate/FoundationDayScenario.vue';
import LandingProgramWithStepsPaymentScenario from './formulate/LandingProgramWithStepsPaymentScenario.vue';
import LandingProgramWithStepsNewPaymentScenario from './formulate/LandingProgramWithStepsNewPaymentScenario.vue';
import AlumniWallScenario from './formulate/AlumniWallScenario.vue';

import '~/utils/vue-formulate';
import RecurringPaymentWithParkingScenario from "~/components/panels/formulate/RecurringPaymentWithParkingScenario.vue";

export default {
	name: 'PanelFormulateForm',
	components: {
		LandingProgramPaymentScenario,
		LandingProgramPaymentRedirectOkSuccessScenario,
		DefaultScenario,
		BookingPaymentScenario,
		RegistrationScenario,
		LoyaltyScenario,
		LoyaltyB2bScenario,
		FamilyDayScenario,
		GraduationScenario,
		AlumniWallScenario,
		ProbonoScenario,
		SKOLKOVO100Scenario,
		LeadershipDayScenario,
		FoundationDayScenario,
		RecurringPaymentWithParkingScenario,
		LandingProgramWithStepsPaymentScenario,
		LandingProgramWithStepsNewPaymentScenario,
	},
	mixins: [panel],
	props: {
		formClosed: {
			type: Boolean,
			default: false,
		},
		customClass: {
			type: String,
			default: 'panel form',
		},
	},
	data() {
		return {
			currentComponent: 'DefaultScenario',
		};
	},
	computed: {
		...mapState('cookiesDisclaimer', ['isCookiesAccepted']),
		isFormClosed() {
			let product = true;
			if (this.block.products.length) {
				product = this.block.products.some((el) => {
					if (el.active_to) {
						const date = el.active_to.split(' ');
						const activeTo = moment(`${date[0]}T${date[1]}+03:00`).format();
						const dateNow = moment().format();
						if (dateNow < activeTo) {
							return true;
						}
						return false;
					}
					return true;
				});
			}
			return !product || this.formClosed;
		},
	},
	created() {
		this.currentComponent = this.$options.components[this.block.class_name] ? this.block.class_name : 'DefaultScenario';
	},
	methods: {
		defineCurrentComponent(component) {
			this.currentComponent = component;
		},
	},
};
</script>

<style lang="scss" scoped>
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.field-required {
	&.formulate-input[data-classification='text'] input {
		border: 1px solid red !important;
	}
}

.custom-switch {
	line-height: 1.8;
}
.alert-primary {
	color: $white;
	background-color: $link-color;
	border-color: $link-color;
}

.close_link {
	display: flex;
	align-items: center;
	justify-content: space-between;
	line-height: 1;
	padding: 0;
	border: 0;
	background: transparent;
	outline: 0;
	cursor: pointer;

	&::after {
		position: relative;
		content: "\e915";
		font-family: "sk_icons";
		line-height: 1;
		font-size: .8rem;
		margin-left: 0.5rem;
		padding: 4px;
		cursor: pointer;
	}
}

span {
	margin: 0;
	line-height: 1.3;

	&.price-muted {
		font-size: 1.5rem;
		text-decoration: line-through;
		color: $border-color;
	}
}

.end-price {
	background: #FFFFFF;
	.amount-wrapper {
		border-right: 1px dashed $border-color;
		height: 100%;
		display: flex;
		justify-content: space-between;
		flex-direction: column;
		padding-right: 30px;
	}
}

.amount {
	font-weight: bold;
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	flex-direction: column;
	@include media-breakpoint-up(sm) {
		justify-content: space-between;
		flex-direction: row;
		align-items: center;
	}
}

.total-price {
	padding: 1rem;
	border: 1px solid $border-color;
	display: flex;
	background-color: #455FED;
	color: #FFFFFF;
	flex-direction: column;
	justify-content: space-between;
	@include media-breakpoint-up(sm) {
		padding: 2rem 1.5rem;
	}

	.description-small {
		font-weight: 400;
		line-height: 20px;
		color: #9BA9F7;

	}

	.education {
		border-top: 1px solid #FFFFFF;
	}

	input {
		background-color: transparent;
		border: none;
		border-bottom: 1px solid $border-color;
		width: 100%;
		outline-style: none;

		&::placeholder {
			color: $border-color;
		}
	}

	.input_under_span {
		font-size: 0.8rem;
		line-height: 1.2;
		font-weight: normal;
	}

	.btn-outline-secondary {
		color: $border-color;
		border-color: $border-color;

		&:hover {
			color: $white;
			border-color: $link-hover-color;
			background-color: $link-hover-color;
		}
	}

	.sum {
		margin: 2rem 0;
	}
}
.custom-control-input:checked ~ .custom-control-label::before {
	color: #fff;
	border: #FFFFFF;
}

.discount {
	.formulate-input-element {
		&.formulate-input-element--text {
			input {
				border: none !important;
				border-bottom: 1px solid black !important;
				padding-left: 0px !important;
				padding-bottom: 1rem !important;

				&::placeholder {
					color: black !important;
				}
			}
		}
		&.formulate-input-element--submit {
			button {
				font-weight: 400 !important;
			}
		}

	}
}
</style>
